import moment from 'moment';

export const formatLocalTime = (date, timeFormat12hrs) => {
    let hours = date.getHours();
    const minutes = date.getMinutes();
    let suffix = '';

    if (timeFormat12hrs) {
        suffix = hours >= 12 ? ' PM' : ' AM';
        hours = hours % 12 || 12;
    }

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}${suffix}`;
}



export const parseToGlobalDate = (currentGuest) => {
    if(!currentGuest){
        return;
    }

    let parsedCurrentGuest = {...currentGuest}
    if(parsedCurrentGuest.plannedCheckOutDate?.includes("Z")){
        parsedCurrentGuest.plannedCheckOutDate = parsedCurrentGuest.plannedCheckOutDate.replace("Z", "");
    }

    if(parsedCurrentGuest.checkInDate?.includes("Z")){
        parsedCurrentGuest.checkInDate = parsedCurrentGuest.checkInDate.replace("Z", "");
    }

    return parsedCurrentGuest;
}

export const formatTime = (time, timeFormat12hrs) => {
  let [hours,minutes] = time.split(":");

  let suffix = '';

  if (timeFormat12hrs) {
      suffix = hours >= 12 ? ' PM' : ' AM';
      hours = hours % 12 || 12;
  }

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}${suffix}`;
}

export function formatMinutesToTimeFormat(minutes, is12hourFormat) {
    if (minutes >= 60 * 24) return  ;

    let hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    let suffix = "";

    if (is12hourFormat) {
        if (hours >= 12) {
            suffix = "PM";
            if (hours > 12) {
                hours -= 12;
            }
        } else {
            suffix = "AM";
            if (hours === 0) {
                hours = 12;
            }
        }
    }

    return `${hours}:${mins.toString().padStart(2, '0')} ${suffix}`.trim();
}

export const dateFormatHandler = (date, format) => {
    if (!date || date == null){
        return;
    }
  
    const dateObj = moment.utc(date);
    return dateObj.format(`${format && format != "null" ? format.toUpperCase() : "YYYY-MM-DD"}`);
  }



export const makeStringStrictlyCapitalize = (s) => {
    if(typeof s !="string") return s;

    let words = s.split(" ")
    const updatedWords = words.map((word)=>{
        if(word=="") return word;
        return String(word[0]).toUpperCase() + String(word).slice(1).toLowerCase();
    });

    return updatedWords.join(" ");
 }

 export const getStyleForRenderHTML = (style) => {
    if(!style || !Object.keys(style)){
        return { baseStyle: {}, systemFonts: {} }
    }
    const baseStyle = Array.isArray(style.fontFamilyArr) ? {...style, fontFamily: style.fontFamilyArr[0]} : style;
    const systemFonts = Array.isArray(style.fontFamilyArr) ? style.fontFamilyArr : [style.fontFamily]

    return { baseStyle, systemFonts }
 }
